import React, { useEffect, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import Header from 'components/AuthStyling';
import { queryStringParser } from '../../utils/queryStringParser';
import API from 'services/api';
import BasePasswordPanel from 'components/Forms/BasePasswordPanel';
import styles from './index.module.scss';

const CreatePassword = ({ location, history }) => {
  const [userId, setUserId] = useState();
  const [token, setToken] = useState();

  const verifyToken = useCallback(async () => {
    try {
      const userId = queryStringParser(location.search, 'u');
      const token = queryStringParser(location.search, 't');
      if (userId !== null && token !== null) {
        setUserId(userId);
        setToken(token);
        await API.verifyToken(userId, token);
      }
    } catch (err) {
      history.push('/pwd-reset/failure');
      console.log(`error: ${err}`);
    }
  }, [location.search, history]);

  useEffect(() => {
    verifyToken();
  }, [verifyToken]);

  const createPwd = useCallback(
    async pwd => {
      try {
        await API.createPassword(userId, token, pwd);
        history.push('/create-pwd/success');
      } catch (err) {
        history.push('/pwd-reset/failure');
        console.log(err);
      }
    },
    [userId, token, history],
  );

  return (
    <Header message="Create password below" className={styles.LegalPara}>
      <BasePasswordPanel submit={createPwd} submitBtnText="Confirm" />
    </Header>
  );
};

CreatePassword.propTypes = {
  location: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};

export default CreatePassword;
